import { IGet } from '../interfaces';
import { apiStatic } from '../../../helpers';
import axios from 'axios';
import { queryEncoderObject } from 'components/helpers';

export const requestGet = ({ url, data, cancelToken }: IGet) => {
  return new Promise((resolve: (response: any) => void, reject: (error: any) => void) => {
    apiStatic({
      method: 'post',
      url: url,
      cancelToken: cancelToken?.token,
      data: data ? queryEncoderObject(data) : undefined,
    })
      .then(resolve)
      .catch((error) => {
        if (!axios.isCancel(error)) reject(error);
      });
  });
};
